import React from "react";
import PropTypes from "prop-types";
import Text from "components/typography/Text";

const SelectedElement = ({
	data,
	isLastFilter,
	labelToLowerCase,
	textSmall,
}) => {
	if (data?.label !== "") {
		return (
			<>
				<Text block mr={1} size={textSmall && "0.85rem"}>
					{labelToLowerCase ? data.label.toLowerCase() : data.label}:
				</Text>
				<Text
					mr={isLastFilter ? 2 : 1}
					bold
					size={textSmall && "0.85rem"}
				>
					{typeof data.selected === "string" && data.selected}
					{typeof data.selected === "number" && data.selected}
					{typeof data.selected === "function" && data.selected()}
					{Array.isArray(data.selected) &&
						data.selected.map(({ content }, index) => (
							<React.Fragment key={index}>
								{content}
								{index + 1 < data.selected.length && ", "}
							</React.Fragment>
						))}
					{!isLastFilter && <span>,</span>}
				</Text>
			</>
		);
	}
	return null;
};

SelectedElement.propTypes = {
	data: PropTypes.object.isRequired,
	/**
	 * Props informujacy czy dany filtr jest ostatni,
	 * wówczas nie będzie dodawany po nim przecinek
	 */
	isLastFilter: PropTypes.bool,
	/**
	 * Props odpowiadajacy za wielkość liter podczas wyświetlania
	 * etykiet wybranych filtrów
	 * > true (małe litery) - np. w users
	 * > false (wielkie litery) - np. w rankings
	 */
	labelToLowerCase: PropTypes.bool,
};

SelectedElement.defaultProps = {
	isLastFilter: false,
	labelToLowerCase: true,
};

export default SelectedElement;
